import { createAsyncThunk } from '@reduxjs/toolkit';

// A small, self-contained thunk used only for the live keyword-search dropdown
// on the mobile search results page bar. Scoped locally to this component so
// it never touches SearchPage's own Redux state, or the other two separate
// copies of this same pattern (Topbar and homepage SearchCTA).
export const searchKeywordSuggestions = createAsyncThunk(
  'SearchPageSearchBar/searchKeywordSuggestions',
  async ({ keywords, perPage = 6 }, thunkAPI) => {
    const sdk = thunkAPI.extra;
    const response = await sdk.listings.query({
      keywords,
      perPage,
      'fields.listing': ['title'],
    });
    return response.data.data;
  }
);
